
                            const shader = `precision highp float;

uniform bool uMobile;

uniform vec2 uMouse;
uniform float uSpeed;
// uniform float uScrollSpeed;
uniform sampler2D tLast;

varying vec2 vUv;

void main() {
	vec4 lastPos = texture2D(tLast, vUv);
    
    // vec4 lastPos = vec4(0.);

    // lastPos.x = texture2D(tLast, vec2(vUv.x + TEXEL_SIZE * 2.0 * (1. + vUv.x), vUv.y)).x;
    // lastPos.y = texture2D(tLast, vec2(vUv.x + TEXEL_SIZE * 1.0 * (1. + vUv.x), vUv.y)).y;
    // lastPos.z = texture2D(tLast, vec2(vUv.x + TEXEL_SIZE * 1.5 * (1. + vUv.x), vUv.y)).z;
    // lastPos.w = texture2D(tLast, vec2(vUv.x + TEXEL_SIZE * 2.5 * (1. + vUv.x), vUv.y)).w;

 	// vec2 currentPos = uMouse;
    
    // float interpolationFactor = vUv.x;
    // interpolationFactor = smoothstep(1. - TEXEL_SIZE * 10., 1., vUv.x);

    float drawSize = uMobile ? 0.25 : 0.1;

    float currentMouse = smoothstep(drawSize, 0., length(vec2(vUv.x, vUv.y) - (1. - uMouse)));

    vec4 final = vec4(vec3(0.), 1.);

    float fadeFactor = uMobile ? 0.16 : 0.08; // This factor controls how fast it fades out
    final.rgb = vec3(currentMouse) + (1.0 - fadeFactor) * lastPos.rgb;


    // final.x = mix(lastPos.x, currentPos, uSpeed * uDelta * interpolationFactor * .5 * (1. - min(1., abs(uScrollSpeed) * 2.)));
    // final.y = mix(lastPos.y, currentPos, uSpeed * uDelta * interpolationFactor * .4 * (1. - min(1., abs(uScrollSpeed) * 1.5)));
    // final.z = mix(lastPos.z, currentPos, uSpeed * uDelta * interpolationFactor * .6 * (1. - min(1., abs(uScrollSpeed) * 1.)));
    // final.w = mix(lastPos.w, currentPos, uSpeed * uDelta * interpolationFactor * .7 * (1. - min(1., abs(uScrollSpeed) * .5)));

    gl_FragColor = final;
}
`;

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = shader;
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        